import { render } from "./animated_fire.vue?vue&type=template&id=b3daee4c&scoped=true"
import script from "./animated_fire.vue?vue&type=script&lang=js"
export * from "./animated_fire.vue?vue&type=script&lang=js"

import "./animated_fire.vue?vue&type=style&index=0&id=b3daee4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3daee4c"]])

export default __exports__